import { CartItem } from "@src/types/CartItemListResponse";
import React, { createContext, useState, useContext, ReactNode } from "react";

interface CartItemsContextType {
  cartItems: CartItem[];
  setCartItems: React.Dispatch<React.SetStateAction<CartItem[]>>;
}

const CartItemsContext = createContext<CartItemsContextType | undefined>(
  undefined
);

export const CartItemsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  return (
    <CartItemsContext.Provider value={{ cartItems, setCartItems }}>
      {children}
    </CartItemsContext.Provider>
  );
};

export const useCartItems = () => {
  const context = useContext(CartItemsContext);
  if (context === undefined) {
    throw new Error("useCartItems must be used within a CartItemsProvider");
  }
  return context;
};
